import { Fragment, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetSettingsListAtom,
  SetSettingsListAtom,
} from "../../store/settingsAtom";
import { settingsService } from "../../services/settingsService";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

function FeatureSearch() {
  const getFeatureList = GetSettingsListAtom();
  const setFeatureList = SetSettingsListAtom();
  const [searchResult, setSearchResult] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [textInput, setTextInput] = useState("");
  const navigate = useNavigate();
  const mountedRef = useRef(true);

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    mountedRef.current = true;
    if (getFeatureList.action_url_info?.length < 1) {
      fetchDataFromServer();
    }

    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFeatureList]);

  const fetchDataFromServer = () => {
    settingsService.getFeatureList().then((res) => {
      if (res.data?.action_url_info?.length) {
        setFeatureList(res.data);
        setVendorList(res.data?.feature_info);
      }
    });
  };

  function itemSearchChange(search: string) {
    setTextInput(search);

    if (search.length < 2) {
      setSearchResult([]);
    } else {
      var tempResult = vendorList?.filter((featr: any) => {
        return (
          featr?.Encoded_By_Name?.toLowerCase().indexOf(search.toLowerCase()) >=
            0 ||
          featr?.Feature_Name?.toLowerCase().indexOf(search.toLowerCase()) >=
            0 ||
          featr?.Last_Changed_By?.toLowerCase().indexOf(search.toLowerCase()) >=
            0
        );
      });

      setSearchResult(tempResult);
    }
  }

  function selectedOption(feature: any) {
    const { Ref_No } = feature;
    setSearchResult([]);
    setTextInput("");
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${Ref_No}`
    );
  }

  return (
    <>
      <Combobox>
        <div className="relative max-w-sm w-full">
          <div className="relative">
            <Combobox.Input
              className=" w-full rounded-full border font-medium border-gray-300 bg-white py-1.5 pl-10 pr-4 text-sm text-gray-800 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600"
              // displayValue={(person) => person.name}
              placeholder="Search in Features"
              onChange={(event) => itemSearchChange(event.target.value)}
              // onChange={(event) => setTextInput(event.target.value)}
            />
            <Combobox.Button className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5 text-gray-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
              </svg>
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setTextInput("")}
          >
            <Combobox.Options className="absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black/10 focus:outline-none">
              {searchResult.length === 0 && textInput !== "" ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                searchResult.map((invoice: any, i: number) => (
                  <Combobox.Option
                    key={i}
                    onClick={() => selectedOption(invoice)}
                    className={({ active }) =>
                      `relative cursor-pointer select-none text-xs font-medium py-2 pl-10 pr-4 ${
                        active ? "bg-gray-100 text-white" : "text-gray-700"
                      }`
                    }
                    value={invoice}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={` ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {invoice.Invoice_No} |{invoice?.Customer_Full_Name}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? "text-white" : "text-gray-700"
                            }`}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </>
  );
}

export default FeatureSearch;
